import { useContainerBlockContext } from '@lighthouse/block'
import type { TableColumnWidth } from '@lighthouse/core'
import { getWithScopeId, useAtomAction } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import { useCallback, useMemo } from 'react'

import { tableColumnCacheAtomFamily } from '@/atoms/storage/state'

interface useTableColumnPayload {
    appId: string
    envId: string
    blockId: string
}

export const useTableColumn = (payload: useTableColumnPayload) => {
    const { appId, envId, blockId } = payload
    const { scope } = useContainerBlockContext()
    const withScopeId = getWithScopeId(blockId, scope)
    const { run: setTableColumnCache } = useAtomAction(tableColumnCacheAtomFamily({ appId, envId, id: withScopeId }))
    const tableColumnCache = useAtomValue(tableColumnCacheAtomFamily({ appId, envId, id: withScopeId }))

    const handleTableColumnWidthChange = useCallback(
        (val: TableColumnWidth) => {
            const column = {
                ...tableColumnCache,
                ...val
            }
            setTableColumnCache(column)
        },
        [setTableColumnCache, tableColumnCache]
    )

    return useMemo(() => ({ tableColumnCache, handleTableColumnWidthChange }), [handleTableColumnWidthChange, tableColumnCache])
}
